// see src/app/shared/constant/analytics/EventType.ts:1 in optim-portal-front
export class AnalyticsEventType {
  static readonly appList = 'ListeApp';
  static readonly assistance = 'Assistance';
  static readonly table = 'Tableau';
  static readonly contact = 'Contact';
  static readonly publications = 'Publications';
  static readonly events = 'Evenements';
  static readonly actionTools = 'ActionOutils';
}
